import { render, staticRenderFns } from "./ProfilePM.vue?vue&type=template&id=b0afd428"
import script from "./ProfilePM.vue?vue&type=script&lang=js"
export * from "./ProfilePM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports